export default __webpack_public_path__ + "static/media/fb.27a4a641.jpg";